<div class="ion-text-center position-relative pt-64 help-header">
  <div class="back-arrow-header" (click)="back()" *ngIf="showBackButton">
    <img src="assets/back_arrow_new.svg" />
  </div>
  <img [class]="logoClass" [src]="logoSrc" />
  <div class="help-icon" (click)="openHelpCenter()">
    <ion-icon name="help-circle-outline"></ion-icon>
  </div>
</div>
